export { default } from './CardMedia';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/CardMedia/index.js
// module id = 661
// module chunks = 0